export default __webpack_public_path__ + "static/media/checkmark-medium.cbf233c2.svg";